// @ts-check
import { ResourceManager } from "./resource";
import { FIXED_FRAME_RATE, EVENT_ENGINE_PRE_START, EVENT_ENGINE_POST_START, EVENT_ENGINE_PRE_STOP, EVENT_ENGINE_POST_STOP } from "../global";

/**
 * Engine
 */
export default class Engine {
    constructor() {
        // Attributes
        this.loading = true;
        this.disposed = false;
        this.wheel = undefined;
        this.context = undefined;
        this.events = new Array(100);
        this.eventFilter = 0xffff;
        this.keydown = [];
        this.last = Date.now();
        this.touch = {};
    }

    /**
     * Start
     */
    async start(wheel) {
        // Init this
        this.wheel = wheel;
        const canvas = document.querySelector("#" + this.wheel.canvas);
        this.context = canvas.getContext("2d");

        // Initialize input listener
        window.addEventListener("keydown", e => this.keypressed(e));

        // Keydown mechanism
        window.addEventListener("keydown", e => (this.keydown[e.which] = true));
        window.addEventListener("keyup", e => (this.keydown[e.which] = undefined));

        // Touch events
        ["touchstart", "touchend", "touchmove"].map(event => canvas.addEventListener(event, e => this.keypressed(e)));

        // Initialize components
        this.wheel.components.forEach(component => {
            component.engine = this;
            component.state = this.wheel.state;
            component.context = this.context;
            component.init();
        });

        // Fire event
        this.fireEvent(EVENT_ENGINE_PRE_START);

        // Start loop
        this.loop();

        // Load resource manager
        await ResourceManager.load();

        // Loading is finished
        this.loading = false;

        // Fire event
        this.fireEvent(EVENT_ENGINE_POST_START);
    }

    /**
     *
     */
    dispose() {
        // FIXME Remove listeners

        // Fire event
        this.fireEvent(EVENT_ENGINE_PRE_STOP);

        // Set dispose flags
        this.disposed = true;

        // Dispose components
        this.wheel.components.map(component => component.dispose());

        // Fire event
        this.fireEvent(EVENT_ENGINE_POST_STOP);
    }

    /**
     * Fire new event
     */
    fireEvent(type, delay) {
        var event = {
            type: type,
            delay: delay
        };

        for (var i = 0; i < this.events.length; i++) {
            if (this.events[i] == undefined) {
                this.events[i] = event;
                break;
            }
        }
    }

    /**
     *
     */
    clearEvents(mask) {
        for (var i = 0; i < this.events.length; i++) {
            var event = this.events[i];
            if (event != undefined && (mask & event.type) == mask) {
                this.events[i] = undefined;
            }
        }
    }

    enableEventFilter(mask) {
        this.eventFilter ^= mask;
    }

    disableEventFilter(mask) {
        this.eventFilter |= mask;
    }

    /**
     *
     */
    workhorse() {
        // Render loading?
        if (this.loading) {
            return this.renderLoading();
        }

        // Init
        var components = this.wheel.components;

        // Handle events
        for (var i = 0; i < this.events.length; i++) {
            var event = this.events[i];
            if (event != undefined && (event.type & this.eventFilter) == event.type) {
                if (event.delay != undefined) {
                    event.delay -= FIXED_FRAME_RATE;
                }

                if (event.delay == undefined || event.delay <= 0) {
                    // Handle event for all components
                    for (var j = 0; j < components.length; j++) {
                        components[j].handleEvent(event);
                    }

                    this.events[i] = undefined;
                }
            }
        }

        // Update components
        for (var i = 0; i < components.length; i++) {
            components[i].update();
        }

        // Render components
        for (var i = 0; i < components.length; i++) {
            components[i].render();
        }
    }

    /**
     *
     */
    loop() {
        // Break?
        if (this.disposed) {
            return;
        }

        // Loop
        requestAnimationFrame(() => this.loop());

        // Calc constant frame rate
        const now = Date.now();
        const elapsed = now - this.last;
        if (elapsed > FIXED_FRAME_RATE) {
            this.last = now - (elapsed % FIXED_FRAME_RATE);

            // Workhorse
            this.workhorse();
        }
    }

    /**
     *
     */
    keypressed(event) {
        // Init
        var components = this.wheel.components;

        // Update input on components
        for (var i = 0; i < components.length; i++) {
            components[i].input(event);
        }
    }

    /**
     * Private
     */
    renderLoading() {
        // Init
        var context = this.context;
        var w = context.canvas.width;
        var h = context.canvas.height;
        var w2 = w / 2;
        var h2 = h / 2;

        // Draw loading screen
        context.save();
        context.clearRect(0, 0, w, h);
        context.lineWidth = 2;
        context.strokeStyle = "#444";
        context.beginPath();
        context.moveTo(w2 - 50, h2);
        context.lineTo(w2 + 50, h2);
        context.stroke();
        context.strokeStyle = "#00ff66";
        context.beginPath();
        context.moveTo(w2 - 50, h2);
        context.lineTo(w2 - 50 + 100 * ResourceManager.loadingState, h2);
        context.stroke();
        context.restore();
    }
}
